import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseResolver } from '@principle-theorem/ng-shared';
import { TreatmentConfiguration } from '@principle-theorem/principle-core';
import {
  type IBrand,
  type ITreatmentConfiguration,
} from '@principle-theorem/principle-core/interfaces';
import { type CollectionReference } from '@principle-theorem/shared';
import { type WithRef } from '@principle-theorem/shared';

@Injectable()
export class BrandTreatmentConfigurationCollectionResolverService extends BaseResolver<
  CollectionReference<ITreatmentConfiguration>
> {
  resolve(
    route: ActivatedRouteSnapshot
  ): CollectionReference<ITreatmentConfiguration> {
    const brand = this._findInheritedRouteData<WithRef<IBrand>>(route, 'brand');
    if (!brand) {
      throw new Error('No Brand found');
    }
    return TreatmentConfiguration.col(brand);
  }
}
